module.exports = __webpack_public_path__ + "static/media/_MIC2359.thumbnail.3eb8b327.png";